<div class="my-google-map">
  <div class="map-container">
    <google-map #map [options]="options">
      <!-- Only show polyline and markers if we have data -->
      @if (basicRideCoordinateDto?.coordinates) {
        <map-polyline
          [path]="basicRideCoordinateDto.coordinates"
          [options]="{ strokeColor: '#2e6fa6', strokeWeight: 5 }"
        />
      }
      @if (markers && markers.length > 0) {
        @for (mark of markers; track mark) {
          <map-marker
            #markerData="mapMarker"
            [position]="mark.position"
            [icon]="mark.icon"
          />
        }
      }
      <map-info-window #mapInfoWindow="mapInfoWindow" />
    </google-map>
  </div>
</div>
